import React from "react";
import { Divider, Flex, Button } from "antd";
import queryString from 'query-string';
import { detectScreen } from '../../utils/device';

const screen = detectScreen();

export default () => {
    const [detail, setDetail] = React.useState({});

    React.useEffect(() => {
        getDetail().then(res => {
            console.log(res);
            setDetail(res);
        });
    }, []);
    const getDetail = async () => {
        const [path, params] = window.location.href.split('?')
        const paramsObj = queryString.parse(params || '') || {};
        const response = await fetch(`/api/channel/oauth/detail?type=${paramsObj.type}`);
        const result = await response.json();

        if(result?.success) {
            return result.data;
        }
        return {};
    }

    return (
        <div>
            <h2>小程序信息</h2>
            <Divider />
            <Flex gap={10} wrap="wrap" style={{fontSize: '16px'}}>

                <div style={{width: '100%'}}>
                    <img src={detail?.head_image_info?.head_image_url} width={30} style={{ verticalAlign: 'middle' }} />
                    {detail.nickname}
                </div>
                <div>appId：{detail.appid}</div>
                <div>主体名称：{detail.principal_name}</div>
            </Flex>
            <Divider />
            <Button href={`/wxopen/oauth?pageType=${screen}`}>重新授权</Button>
        </div>
    )
}